import { Station } from 'dataSources/Typicode/stations';
import { useGetCountryByCode } from 'store/features/directories';
import { Leg } from 'common/utils/Route';
import { point } from '@turf/helpers';
import { useSortStationsByDistance } from './useSortStationsByDistance';
import { useMemo } from 'react';

export const useSelectedStationByCountry = (countryCodes: string[], stations: Station[], startPoint: Leg) => {
  const getCountryByCode = useGetCountryByCode();

  const { lat, lng } = startPoint.location;
  const reference = point([lat, lng]);
  const sortPoint = useSortStationsByDistance();
  return useMemo(
    () =>
      countryCodes.reduce(
        (acc, routeCountryCode) => {
          const country = getCountryByCode(routeCountryCode);
          const countryStations = stations.filter(({ code }) =>
            code.toUpperCase().startsWith(routeCountryCode.toUpperCase())
          );

          if (countryStations.length === 0) {
            return acc;
          }

          acc.push({
            countryName: country ? country.name : routeCountryCode,
            stations: sortPoint(countryStations, reference),
          });

          return acc;
        },
        [] as { countryName: string; stations: Station[] }[]
      ),
    [countryCodes, getCountryByCode, stations, sortPoint, reference]
  );
};
